import { useQuery } from '@tanstack/react-query'
import apiSetting from '../services/setting'

export function useContractAgreement({ id_project, id_invoice } = {}) {
  return useQuery({
    queryKey: ['contract_agreement', id_project, id_invoice],
    queryFn: () => apiSetting.ContractAgreement({ id_project, id_invoice }),
    enabled: !!(id_project && id_invoice),
    staleTime: 1000 * 60 * 5, // cache 5 นาที
  })
}

